import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useUiTheme } from '@/hooks/use-ui-theme';
import OldBookingDetail from './booking-detail-old';
import MissionControlBookingDetail from './booking-detail-mission-control';
export default function POSBookingDetail(props) {
    const { uiTheme } = useUiTheme();
    return uiTheme === 'classic' ? (_jsx(OldBookingDetail, { ...props })) : (_jsx(MissionControlBookingDetail, { ...props }));
}
